import { Saida } from '../models';
import { makeCrudObject } from './api';

export const saidaApi =  makeCrudObject<Saida>('saida');
